module.exports = __webpack_public_path__ + "static/media/Icon feather-menu.1f954189.svg";